// extracted by mini-css-extract-plugin
export default {"MockupList":"MockupList_MockupList__iyMmb","loader":"MockupList_loader__cJmHt"};